import { ContentCards } from "../../components/Reusable/resuable";
import { allImages } from "../../services/images";
import { Heading, FiveStarRating } from "../../components/Reusable/resuable";
import { Carousel } from "react-bootstrap";
import { testimonials, clients } from "../../services/data";
import { useAppSelector } from "../../Redux/hook";
import { FaQuoteLeft, FaQuoteRight } from "react-icons/fa";
import { Helmet } from "react-helmet-async";
import './clients.scss';
function Clients() {
    const lightMode = useAppSelector((state) => state.mode.lightMode);
    return (
        <div className="clients">
            <Helmet>
                <title>Clients - PBL Transport</title>
            </Helmet>
            <ContentCards id={998} heading={"Clients"}
                content={"PBL Transport takes pride in serving a diverse and dynamic range of clients, catering to the unique transportation needs of businesses. Our client base includes small and medium-sized enterprises seeking cost-effective and reliable logistics solutions, as well as large corporations with complex supply chain demands. We work closely with manufacturers, distributors, retailers, and e-commerce companies, ensuring the efficient movement of goods throughout the entire supply chain. Additionally, PBL Transport extends its services to individuals in need of personal relocation or specialized transport services, offering a seamless and dependable experience. Regardless of the client’s size or specific requirements, we are committed to delivering top-notch transportation services that prioritize safety, timeliness, and customer satisfaction."}
                image={allImages.shakehand} reverse={false} />
            <ClientList lightMode={lightMode} />
            <Testimonial lightMode={lightMode} />
        </div>
    );
}

function CommentCard({ one = 0 }) {
    return <div className="testimonialCards">
        <div className="testimonial">
            <div className="rating"><FiveStarRating /></div>
            <div className="commentBox"><FaQuoteLeft className="left" size={20} /><div className="comment">{testimonials[one].comment}</div><div className="right" ><FaQuoteRight size={20} /></div></div>
            <div className="IMAGE">
                <img src={testimonials[one].logo} alt="logo" style={{ background: "black", padding: "10px", borderRadius: "10px" }} />
            </div>
        </div>
        {/* {mobile ? <span /> : <div className="testimonial">
            <div className="rating"><FiveStarRating /></div>
            <div className="commentBox"><FaQuoteLeft className="left" size={20} /><div className="comment">{testimonials[two].comment}</div><div className="right" ><FaQuoteRight size={20} /></div></div>
            <div className="IMAGE">
                <img src={testimonials[two].logo} alt="logo" style={{ background: "black", padding: "10px", borderRadius: "10px", width: "300px" }} />
            </div>
        </div>} */}
    </div>
}

function Testimonial({ lightMode = false }) {
    var interval = 2000;
    return (
        <div className="testimonials">
            <div className="clients test">
                <Heading lightMode={lightMode} heading="Testimonial" subclass="pc" />
                <div>
                    <Carousel controls={true} indicators={true} >
                        {testimonials.map((item, i) => <Carousel.Item interval={interval}>
                            <CommentCard key={i} one={i}/>
                        </Carousel.Item>)}
                    </Carousel>
                </div>
            </div>
        </div>);
}

function ClientList({ lightMode = false }) {
    return <div className="testimonials">
        <div className="clients">
            <Heading lightMode={lightMode} heading="OUR CLIENTS" subclass="pc" />
            <div className="rows threegrid">
                {
                    // clients.map((item, i) => {
                    //     return <div className="adcard">
                    //         <img src={item.logo} alt="abb" />
                    //         {/* <span>{item.name}</span> */}
                    //     </div>
                    // })
                }
                <div className="adcard"><img src={clients[0].logo} alt="client0" /></div>
                <div className="adcard"style={{background:"#085D6B"}}><img src={clients[2].logo} alt="client2" /></div>
                <div className="adcard"><img src={clients[1].logo} alt="client1" /></div>

                <div className="adcard" ><img src={clients[3].logo} alt="client3" style={{height:"70px"}} /></div>
                <div className="adcard" style={{background:"#085D6B"}}><img src={clients[4].logo} alt="client4" style={{height:"50px"}} /></div>
                <div className="adcard"><img src={clients[5].logo} alt="client5" /></div>

                <div className="adcard"><img src={clients[6].logo} alt="client6" style={{height:"70px"}} /></div>
                <div className="adcard" style={{background:"#085D6B"}}><img src={clients[7].logo} alt="client7" style={{height:"90px"}} /></div>
                <div className="adcard"><img src={clients[8].logo} alt="client8" /></div>

                <div className="adcard"><img src={clients[15].logo} alt="client15" style={{height:"90px"}}/></div>
                <div className="adcard"style={{background:"#085D6B"}}><img src={clients[12].logo} alt="client12" /></div>
                <div className="adcard"><img src={clients[10].logo} alt="client10" /></div>

                <div className="adcard"><img src={clients[11].logo} alt="client11"  style={{height:"90px"}} /></div>
                <div className="adcard"style={{background:"#085D6B"}}><img src={clients[16].logo} alt="client16" style={{height:"50px"}}/></div>
                <div className="adcard"><img src={clients[13].logo} alt="client13" style={{height:"90px"}}/></div>

                <div className="adcard"><img src={clients[19].logo} alt="client19" style={{height:"90px"}}/></div>
                <div className="adcard" style={{background:"#085D6B"}}><img src={clients[9].logo} alt="client9" /></div>
                <div className="adcard"><img src={clients[17].logo} alt="client17" style={{height:"90px"}}/></div>

                <div className="adcard"><img src={clients[18].logo} alt="client18" style={{height:"90px"}}/></div>
                <div className="adcard"style={{background:"#085D6B"}}><img src={clients[14].logo} alt="client14" style={{height:"90px"}}/></div>
                <div className="adcard"><img src={clients[20].logo} alt="client20" style={{height:"90px"}}/></div>


            </div>
        </div></div>
}
export { Clients, Testimonial };